import { Params } from '@angular/router';

export function toLowerCaseParams(params: Params): Params {
  const lowerParams: Params = {};
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      lowerParams[key.toLowerCase()] = params[key];
    }
  }
  return lowerParams;
}
